<template>
  <div>
       <header>
          <div class="headerOne">
              <i class="el-icon-arrow-left" @click="$router.go(-1)"></i>
                <span class="buss">{{msg}}</span>
          </div>
      </header>
      <div class="juzhong"></div>
     <ul>
       <li>
          <p class="onePen">该功能占未开放，敬请期待</p>
       </li>
     </ul>
  </div>
</template>
<script>
export default {
    data(){
        return{
          msg:"全部商家"
        }
    }
}
</script>
<style scoped>
ul li{
    padding-left: 0.4rem;
    margin-top: 0.5rem
}
ul li p.onePen{
   color: rgba(0,0,0,0.90);
   font-size: 0.55rem
}
ul li div{
   color: rgba(0,0,0,0.50);
   font-size: 0.5rem
}
.firstLi{
    margin-top: 0.35rem
}
.firstDiv{
    /* width: 90%; */
    margin-top: 0.1rem;
    text-indent: -2rem;
         margin-left: 2rem;
}
i{
    font-size: 0.8rem;
    line-height:1.6rem;
     margin-left: 0.2rem
}
header {
  height: 1.6rem;
  width: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  /* position: relative; */
  position: fixed;
  top: 0;
  left: 0;
  background: white;
}
.juzhong {
  height: 1.6rem;
  width: 100%;
}
.headerOne {
  font-size: 0;
}
.headerOne img {
  display: inline-block;
  margin-top: 0.3rem;
}
.headerOne img:nth-child(1) {
  margin-left: 0.2rem;
}
.headerOne .buss {
  display: inline-block;
  font-size: 0.55rem;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/components/allBusinesses/allBusinesses.vue